var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[(_vm.isLoadingScreen)?_c('LoadingScreen'):_c('ResultComponent',{attrs:{"dataSource":_vm.dataSource,"dataApi":_vm.dataApi,"date":_vm.date,"current":_vm.current,"currentTottal":_vm.currentTottal,"isLoadingSmall":_vm.LoadingScreenSmall},on:{"typeGame":_vm.changeTypeGame,"changeDateFilter":_vm.changDateFilter}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }